module.exports = __webpack_public_path__ + "static/img/map8.3e3d491.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/map8.jpg
// module id = 4aEZ
// module chunks = 1